import { PreviousLocationContext } from "app/components/PreviousLocation";
import { useContext } from "react";

export function usePreviousLocation() {
  const { previousLocation } = useContext(PreviousLocationContext);

  return { previousLocation };
}
